import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setUser } from './redux-state/auth/authSlice';
import { RootState } from './redux-state/store';
import { verifyUser } from 'api/auth/_requests';
import { PF, setItemToStore } from 'helpers/utils';
import { router } from 'Routes';
import { RouterProvider } from 'react-router-dom';
import { getWishlist } from 'api/user/_requests';
import { setWishlist } from 'redux-state/user/wishlistSlice';
import { getCart } from 'api/cart/_requests';
import { setCart } from 'redux-state/user/cartSlice';
import { getCustomerProfile } from 'api/user/customer_requests';
import { setCustomerDetails } from 'redux-state/user/customerSlice';
import { getVendorDetails } from 'api/user/vendor_requests';
import { setVendorDetails } from 'redux-state/user/vendorSlice';

interface PopulatedProduct {
  productId: {
    _id: string;
    name: string;
    thumbnail: string;
  } | null;
  variantId: {
    _id: string;
    color?: string;
    size?: string;
    weight?: string;
    price: number;
    discountedPrice: number;
  } | null;
  quantity: number;
}

interface PopulatedCartItem {
  vendorId: string;
  products: PopulatedProduct[];
  totalAmount: number;
  totalAmountAfterDiscount?: number;
  coupon?: {
    code: string;
    discountAmount: number;
  };
}

const AuthInit = () => {
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.auth.user);
  const [wait, setWait] = useState(true);

  useEffect(() => {
    const initializeUser = async () => {
      try {
        const res = await verifyUser();
        if (res) {
          dispatch(setUser(res));
          setItemToStore('user', JSON.stringify(res));
          if (res.role === 'customer') {
            const customerDetails = await getCustomerProfile();
            dispatch(setCustomerDetails(customerDetails));

            const cart = await getCart();
            const temp = (cart as PopulatedCartItem[])
              .map(item => {
                const validProducts = item.products.filter(
                  p => p.productId && p.variantId
                );

                return {
                  vendorId: item.vendorId,
                  products: validProducts.map(p => ({
                    productId: p.productId!._id,
                    variantId: p.variantId!._id,
                    price: p.variantId!.discountedPrice,
                    quantity: p.quantity,
                    name: p.productId!.name,
                    color: p.variantId!.color,
                    size: p.variantId!.size,
                    discountedPrice: p.variantId!.discountedPrice,
                    weight: p.variantId!.weight,
                    thumbnail: PF + (p.productId!.thumbnail ?? 'goods'),
                    vendorId: item.vendorId
                  })),
                  totalAmount: item.totalAmount,
                  tottotalAmountAfterDiscount:
                    item.totalAmountAfterDiscount ?? 0,
                  coupon: item.coupon ?? undefined
                };
              })
              .filter(item => item.products.length > 0);

            dispatch(setCart(temp));

            const wishlist = await getWishlist();
            dispatch(setWishlist(wishlist));
          } else {
            const vendorDetails = await getVendorDetails();
            dispatch(setVendorDetails(vendorDetails));
          }
        }
      } catch (error) {
        console.error('Failed to verify user', error);
      }

      setWait(false);
    };

    initializeUser();
  }, []);

  if ((user === undefined || user === null) && wait) {
    return <div>Loading...</div>;
  }
  return <RouterProvider router={router} />;
};

export default AuthInit;
